import { render, staticRenderFns } from "./EmojiEditor.vue?vue&type=template&id=a957a918&scoped=true"
import script from "./EmojiEditor.vue?vue&type=script&lang=js"
export * from "./EmojiEditor.vue?vue&type=script&lang=js"
import style0 from "./EmojiEditor.vue?vue&type=style&index=0&id=a957a918&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a957a918",
  null
  
)

export default component.exports